import React from 'react';
import { Phone, MessageCircle, Clock, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const NewTopBar = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div 
      className="bg-[#0E1114] text-[#B9B3A7] text-[13px] h-11 border-b border-[#23282E]"
      data-testid="topbar"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-[120px] h-full flex items-center justify-between">
        {/* Left side */}
        <div className="flex items-center gap-5 xl:gap-7">
          <a 
            href="tel:+38638184060" 
            className="flex items-center gap-2 text-inherit no-underline hover:text-[#F4EFE6] transition-colors"
          >
            <Phone className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">+386 3 818 40 60</span>
            <span className="sm:hidden">Pokliči</span>
          </a>
          
          <span className="hidden lg:flex items-center gap-2">
            <MessageCircle className="w-3.5 h-3.5" />
            <span>Viber · </span>
            <a 
              href="https://api.whatsapp.com/send?phone=38651438441" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-inherit underline underline-offset-2"
            >
              WhatsApp
            </a>
            <span> · Telegram </span>
            <a 
              href="https://api.whatsapp.com/send?phone=38651438441" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-inherit underline underline-offset-2"
            >
              +386 51 438 441
            </a>
          </span>
          
          <span className="hidden xl:flex items-center gap-2">
            <Clock className="w-3.5 h-3.5" />
            <span>{language === 'sl' ? 'Pon–pet 08:00–16:00' : 'Mon–Fri 08:00–16:00'}</span>
          </span>
        </div>

        {/* Right side */}
        <div className="flex items-center gap-5">
          <span className="hidden xl:flex items-center gap-2">
            <MapPin className="w-3.5 h-3.5" />
            <span>Celjska cesta 47, Rogatec</span>
          </span>
          
          {/* Language switcher */}
          <div className="flex border border-[#343A41] rounded-full p-[3px]">
            <Link
              to="/"
              onClick={() => setLanguage('sl')}
              className={`text-[12px] font-semibold px-2.5 py-1 rounded-full no-underline transition-all ${
                language === 'sl' 
                  ? 'bg-[#C9A462] text-[#0E1114]' 
                  : 'text-[#B9B3A7] hover:text-[#F4EFE6]'
              }`}
              data-testid="lang-sl"
            >
              SL
            </Link>
            <Link
              to="/en"
              onClick={() => setLanguage('en')}
              className={`text-[12px] font-semibold px-2.5 py-1 rounded-full no-underline transition-all ${
                language === 'en' 
                  ? 'bg-[#C9A462] text-[#0E1114]' 
                  : 'text-[#B9B3A7] hover:text-[#F4EFE6]'
              }`}
              data-testid="lang-en"
            >
              EN
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewTopBar;
